import { createContext, useContext, useState, ReactNode } from "react";

interface EntryPageContextValue {
  entryPage: string | null;
  setEntryPage: (page: string) => void;
}

const EntryPageContext = createContext<EntryPageContextValue | null>(null);

export const EntryPageProvider = ({ children }: { children: ReactNode }) => {
  const [entryPage, setEntryPage] = useState<string | null>(null);

  return (
    <EntryPageContext.Provider value={{ entryPage, setEntryPage }}>
      {children}
    </EntryPageContext.Provider>
  );
};

export const useEntryPage = () => {
  const ctx = useContext(EntryPageContext);
  if (!ctx) {
    throw new Error("useEntryPage must be used inside EntryPageProvider");
  }
  return ctx;
};
